import { render, staticRenderFns } from "./MeetingChatComponent.vue?vue&type=template&id=07393139&"
import script from "./MeetingChatComponent.vue?vue&type=script&lang=js&"
export * from "./MeetingChatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports